<section>
  <div class="bg-gray-10 border rounded">
    <strong class="d-block text-md p-3 border-bottom">{{ labels.title }}</strong>

    <div class="p-3">
      <strong class="d-block text-md mb-1">{{ labels.companyName }}</strong>
      <mbs-text-ellipsis
        class="w-100 text-md"
        [tooltip]="companyName() || '-'">
        {{ companyName() || '-' }}
      </mbs-text-ellipsis>
    </div>

    @if (ability.can('read', PermissionsEnum.Administrator)) {
      <div
        class="p-3 border-top"
        [id]="elementSelectors.id.administrators">
        <strong class="d-block text-md mb-2">{{ labels.administrators }}</strong>

        @for (administrator of companyAdministrators(); track administrator) {
          <span class="d-block text-md mb-1">{{ administrator }}</span>
        }

        @if (allCompaniesAdministratorsCount()) {
          <span class="d-block text-md mt-2">{{ allCompaniesAdministrators() }}</span>
        } @else if (!companyAdministrators().length) {
          <span class="d-block text-md text-gray-600">{{ labels.noAdministrators }}</span>
        }
      </div>
    }

    @if (ability.can('read', PermissionsEnum.AddOrRemoveDestinationForCompany)) {
      <div
        class="p-3 border-top"
        [id]="elementSelectors.id.destinations">
        <strong class="d-block text-md mb-2">{{ labels.destinations }}</strong>

        @for (destination of destinations(); track destination.bucketId) {
          <div
            class="d-flex align-items-center"
            [class.mb-2]="!$last">
            <i class="flex-shrink-0 mr-2 mbs-storage mbs-storage-sm mbs-storage_{{ destination.storageAccountType | storageIcon }}"></i>
            <span class="text-md">{{ destination.displayDestinationName }}</span>
          </div>
        } @empty {
          <span class="d-block text-md text-gray-600">{{ labels.noDestinations }}</span>
        }
      </div>

      @if (ability.can('read', PermissionsEnum.RemoteDeploy)) {
        <div
          class="p-3 border-top"
          [id]="elementSelectors.id.templates">
          <strong class="d-block text-md mb-2">{{ labels.templates }}</strong>

          @for (template of selectedTemplates(); track template.id) {
            <div
              class="d-flex align-items-center"
              [class.mb-2]="!$last">
              <span
                class="ico mr-2 text-lg"
                [class.ico-file]="!template.isImageBased"
                [class.ico-imagebased]="template.isImageBased"></span>
              <span class="text-md">{{ template.name }}</span>
            </div>
          } @empty {
            <span class="d-block text-md text-gray-600">{{ labels.noTemplates }}</span>
          }
        </div>
      }
    }
  </div>
</section>
